// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-history-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.history-header {
  text-align: center;
  margin-bottom: 2rem;
}

.history-header h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.history-header h1 span {
  color: #4a6bff;
}

.history-header p {
  color: #666;
  font-size: 1.1rem;
}

.controls-section {
  margin-bottom: 2rem;
}

.search-filter-container {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.search-box {
  position: relative;
  flex: 1 1;
}

.search-box input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s;
}

.search-box input:focus {
  border-color: #4a6bff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(74, 107, 255, 0.2);
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
}

.filter-dropdown select {
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  background-color: white;
  cursor: pointer;
  min-width: 180px;
}

.filter-dropdown select:focus {
  border-color: #4a6bff;
  outline: none;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #4a6bff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-results {
  text-align: center;
  padding: 3rem 0;
  color: #666;
}

.registration-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.registration-table {
  width: 100%;
  border-collapse: collapse;
}

.registration-table th {
  background-color: #f8f9fa;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 2px solid #eee;
}

.registration-table td {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.registration-table tr:last-child td {
  border-bottom: none;
}

.registration-table tr:hover {
  background-color: #f9f9f9;
}

.participant-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.profile-pic {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #eee;
}

.contact-info p {
  margin: 0.25rem 0;
  color: #555;
  font-size: 0.9rem;
}

.contact-info svg {
  margin-right: 0.5rem;
  color: #4a6bff;
  width: 16px;
}

.school-info, .date-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #555;
}

.school-info svg, .date-info svg {
  color: #4a6bff;
}

.status-badge {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge.pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.accepted {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.rejected {
  background-color: #f8d7da;
  color: #721c24;
}

.status-dropdown select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  background-color: white;
}

.status-dropdown select:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.7;
}

.status-dropdown select:focus {
  outline: none;
  border-color: #4a6bff;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #f0f4ff !important;
}

.expanded-row {
  background-color: #f8f9fa;
}

.expanded-row td {
  padding: 0 !important;
}

.additional-details {
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.detail-section h4 {
  color: #555;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.detail-section h4 svg {
  color: #4a6bff;
}

.detail-section p {
  color: #333;
  font-size: 1rem;
  margin: 0;
}

@media (max-width: 992px) {
  .registration-table {
    display: block;
    overflow-x: auto;
  }
  
  .search-filter-container {
    flex-direction: column;
  }
  
  .filter-dropdown select {
    width: 100%;
  }
  
  .additional-details {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/MyComponents/Internship/RegistrationHistory.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".registration-history-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.history-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.history-header h1 {\n  font-size: 2.5rem;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.history-header h1 span {\n  color: #4a6bff;\n}\n\n.history-header p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.controls-section {\n  margin-bottom: 2rem;\n}\n\n.search-filter-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.search-box {\n  position: relative;\n  flex: 1;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: all 0.3s;\n}\n\n.search-box input:focus {\n  border-color: #4a6bff;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(74, 107, 255, 0.2);\n}\n\n.search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #888;\n}\n\n.filter-dropdown select {\n  padding: 0.75rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  background-color: white;\n  cursor: pointer;\n  min-width: 180px;\n}\n\n.filter-dropdown select:focus {\n  border-color: #4a6bff;\n  outline: none;\n}\n\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 0;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #4a6bff;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem 0;\n  color: #666;\n}\n\n.registration-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.registration-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.registration-table th {\n  background-color: #f8f9fa;\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 2px solid #eee;\n}\n\n.registration-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #eee;\n  vertical-align: top;\n}\n\n.registration-table tr:last-child td {\n  border-bottom: none;\n}\n\n.registration-table tr:hover {\n  background-color: #f9f9f9;\n}\n\n.participant-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.profile-pic {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #eee;\n}\n\n.contact-info p {\n  margin: 0.25rem 0;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.contact-info svg {\n  margin-right: 0.5rem;\n  color: #4a6bff;\n  width: 16px;\n}\n\n.school-info, .date-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #555;\n}\n\n.school-info svg, .date-info svg {\n  color: #4a6bff;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.status-badge.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.accepted {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-dropdown select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  background-color: white;\n}\n\n.status-dropdown select:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.status-dropdown select:focus {\n  outline: none;\n  border-color: #4a6bff;\n}\n\n.clickable-row {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.clickable-row:hover {\n  background-color: #f0f4ff !important;\n}\n\n.expanded-row {\n  background-color: #f8f9fa;\n}\n\n.expanded-row td {\n  padding: 0 !important;\n}\n\n.additional-details {\n  padding: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.detail-section h4 {\n  color: #555;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.detail-section h4 svg {\n  color: #4a6bff;\n}\n\n.detail-section p {\n  color: #333;\n  font-size: 1rem;\n  margin: 0;\n}\n\n@media (max-width: 992px) {\n  .registration-table {\n    display: block;\n    overflow-x: auto;\n  }\n  \n  .search-filter-container {\n    flex-direction: column;\n  }\n  \n  .filter-dropdown select {\n    width: 100%;\n  }\n  \n  .additional-details {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
